import React from 'react';
import { Typography } from '@material-ui/core';
import { useContent } from '../../../content/content-provider';
import useStyles from './PrivacyPolicy.styles';

const PrivacyPolicy = () => {
  const classes = useStyles();
  const [content] = useContent();
  return (
    <>
      <Typography variant="subtitle2" align="center" paragraph>
        {content.cookie.line1}
      </Typography>
      <Typography variant="subtitle2" align="center" color="textPrimary">
        {content.cookie.line2}
        <a
          href={content.cookie.link}
          target="_blank"
          data-testid="cookieLink"
          className={classes.linkText}
          rel="noreferrer"
        >
          {content.cookie.text}
        </a>
        {content.cookie.line3}
        <a
          href={content.privacy.link}
          target="_blank"
          data-testid="privacyLink"
          className={classes.linkText}
          rel="noreferrer"
        >
          {content.privacy.text}
        </a>
      </Typography>
    </>
  );
};

export default PrivacyPolicy;
